import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { breadcrumb, log, logException } from '@/lib/logger';
import { toast } from '@/lib/toast';

export function SentryTestPage() {
  return (
    <div className="h-full flex flex-col">
      <div className="w-full max-w-lg space-y-4 p-4 md:p-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-sm">Test Error Tracking</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Button
              variant="destructive"
              className="w-full"
              onClick={() => {
                throw new Error('Sentry test: unhandled error from button click');
              }}
            >
              Throw Unhandled Error
            </Button>

            <Button
              variant="outline"
              className="w-full"
              onClick={() => {
                log('Sentry test: manual log event', { source: 'test-page', timestamp: Date.now() });
                toast.success('Sent log event to Sentry');
              }}
            >
              Send Log Event
            </Button>

            <Button
              variant="outline"
              className="w-full"
              onClick={() => {
                try {
                  JSON.parse('invalid json {{{');
                } catch (err) {
                  logException(err, { source: 'test-page', action: 'parse-json' });
                  toast.success('Sent exception to Sentry');
                }
              }}
            >
              Catch + Report Exception
            </Button>

            <Button
              variant="outline"
              className="w-full"
              onClick={() => {
                breadcrumb('User clicked test breadcrumb', { page: 'sentry-test' });
                toast.success('Added breadcrumb');
              }}
            >
              Add Breadcrumb
            </Button>
          </CardContent>
        </Card>

        <p className="text-xs text-muted-foreground">
          Check your Sentry dashboard after clicking these buttons to confirm events arrive.
        </p>
      </div>
    </div>
  );
}
